import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { ComponentPropsWithoutRef } from "react";

import { t } from "@/i18n-js/instance";

import { RailbarContainer } from "./Railbar/RailbarContainer";

export interface ContentProps extends ComponentPropsWithoutRef<"main"> {
  fullHeight?: boolean;
  fullWidth?: boolean;
  noPadding?: boolean;
}

export const PageContent = ({
  children,
  fullWidth,
  fullHeight = true,
  noPadding,
  className,
  ...props
}: ContentProps) => (
  <main
    aria-label={t("main_content")}
    {...props}
    className={classNames(
      "lg:bg-secondary",
      fullHeight && "h-full",
      fullWidth ? "max-w-none p-0" : "mx-auto max-w-5xl",
      noPadding && "p-0",
      className,
    )}
  >
    <div
      className={classNames(
        "lg:bg-secondary",
        fullHeight && "h-full",
        "max-lg:flex",
      )}
    >
      {children}
    </div>
    <RailbarContainer id="rail-bar-content" />
  </main>
);

export const Content = PageContent;
